/**
 * Die Testfassung, von der Oberflaeche aus gesehen.
 *
 * Eine Abfrage sagt, ob diese Fassung die oeffentliche ist und was vom
 * Kontingent noch frei ist. Sie laeuft auch ohne Anmeldung, damit die
 * Startseite weiss, ob sie ein Anmeldeformular oder die Registrierung zeigt.
 */
import { useCallback, useEffect, useState } from 'react'
import { api, ApiFehler } from './api'

export interface Anmeldedaten {
  vorname: string
  nachname: string
  email: string
  passwort: string
  kanzlei?: string
}

export interface Teststand {
  test: boolean
  angemeldet: boolean
  auszuegeGrenze: number
  seitenGrenze: number
  seitenJeDatei: number
  /** Nur wenn angemeldet. */
  auszuege?: number
  seiten?: number
  frei?: boolean
}

const AUS: Teststand = { test: false, angemeldet: false, auszuegeGrenze: 0, seitenGrenze: 0, seitenJeDatei: 0 }

export function useTeststand(): {
  stand: Teststand
  laedt: boolean
  neuLaden: () => Promise<void>
  registrieren: (daten: Anmeldedaten) => Promise<void>
} {
  const [stand, setzeStand] = useState<Teststand>(AUS)
  const [laedt, setzeLaedt] = useState(true)

  const neuLaden = useCallback(async () => {
    try {
      setzeStand(await api.holen<Teststand>('/api/test/stand'))
    } catch (fehler) {
      // Ohne Testfassung gibt es die Route nicht. Das ist kein Fehler.
      if (fehler instanceof ApiFehler && (fehler.status === 404 || fehler.status === 401)) setzeStand(AUS)
    } finally {
      setzeLaedt(false)
    }
  }, [])

  useEffect(() => {
    void neuLaden()
  }, [neuLaden])

  const registrieren = useCallback(
    async (daten: Anmeldedaten) => {
      await api.senden('/api/test/registrieren', { ...daten, bedingungen: true })
      await neuLaden()
    },
    [neuLaden],
  )

  return { stand, laedt, neuLaden, registrieren }
}
